var path = '/glow/component/glow-module/module-contest/tpl/module-contest.html';
var html = "<thismoment-playlist aria-label={{$ctrl.name}} card-options=$ctrl.cardOptions display-search=$ctrl.displaySearch force-single-column=$ctrl.forceSingleColumn load-items=\"$ctrl.loadItems(limit, offset, search, order, randomcontent, success, error)\" loader-color=$ctrl.loaderColor max-column-count=$ctrl.maxColumnCount paginator-limit=$ctrl.paginatorLimit playlist-id=$ctrl.playlistId playlist-order=$ctrl.playlistOrder></thismoment-playlist> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/glow/component/glow-module/module-contest/tpl/module-contest.html
// module id = 1766
// module chunks = 1